// extracted by mini-css-extract-plugin
export default {"message_container":"PageNotFound_message_container__3xDng","text":"PageNotFound_text__snTaR"};